/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { bulkScenarioDependencyResponseSchema } from './bulkScenarioDependencyResponseSchema';
import { scenarioItemSchema } from './scenarioItemSchema';

export const scenarioItemBulkUpdateResultSchema = z.object({
  changedCount: z.int(),
  get dependencyResult() {
    return z.union([bulkScenarioDependencyResponseSchema, z.null()]).optional();
  },
  get items() {
    return z.array(scenarioItemSchema);
  },
});
